module.exports = __webpack_public_path__ + "img/silver2.17b89721.png";